import { customerService } from "@api/customer";
import type { Customer } from "@api/types";
import { Modal } from "@ui/components/modal";
import useMatchMutate from "@ui/hooks/match-mutate";
import { toast } from "sonner";
import { ApiError, handleApiError } from "@/api/utils";
import * as analytics from "@/lib/analytics";
import useActiveGym from "@/ui/hooks/active-gym";

export interface DeleteModalProps {
  customer: Customer;
  open: boolean;
  setOpen: (val: boolean) => void;
  onSuccess: () => void;
}

export function DeleteModal(props: DeleteModalProps) {
  const matchMutate = useMatchMutate();
  const { gym } = useActiveGym();

  async function deleteCustomer() {
    try {
      await customerService.readAndDelete(props.customer.id);
      toast.success("Contact deleted");
      await matchMutate(/\/customers/);
      analytics.track("Contact Deleted", { gym: gym?.name });
      props.onSuccess();
      props.setOpen(false);
    } catch (err) {
      if (err instanceof ApiError) {
        handleApiError(err);
      }
      throw err;
    }
  }

  return (
    <Modal title="Delete contact" size="xs" open={props.open} setOpen={props.setOpen}>
      <Modal.Content>
        <p className="-mt-4 text-base text-muted-foreground">
          Are you sure you want to delete this contact? This cannot be undone.
        </p>
      </Modal.Content>
      <Modal.Footer>
        <div className="flex items-center justify-end space-x-2">
          <button
            type="button"
            className="btn btn--sm btn--default"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            Cancel
          </button>
          <button onClick={deleteCustomer} type="button" className="btn btn--danger">
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
